var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"size":"small","icon":"el-icon-paperclip","round":""}},[_vm._v("选择文件")]),_c('p',[_vm._v("请选择附件 单个附件不超过50MB")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }